import React from "react";
import { useAuth } from "../context/AuthContext";

function InstallSection({ formData, dispatch, FormInput }) {
  const { isAdmin } = useAuth();

  return (
    <fieldset>
      <legend>Installation Value</legend>
      {!isAdmin && (
        <p
          style={{
            fontSize: "0.9rem",
            color: "#666",
            marginTop: "0.5rem",
            fontStyle: "italic",
          }}
        >
          These values are set globally by administrators.
        </p>
      )}
      <p
        style={{
          fontSize: "0.9rem",
          color: "#666",
          marginTop: "0.5rem",
          marginBottom: "0.75rem",
        }}
      >
        Use either a direct install amount or internal hours times rate. If a
        direct dollar amount is entered, it overrides the hours-based
        calculation in results.
      </p>
      <FormInput
        label="Direct Install Amount ($)"
        field="subcontractor_install_cost"
        value={formData.subcontractor_install_cost}
        dispatch={dispatch}
        type="number"
        step="0.5"
        disabled={!isAdmin}
      />
      <FormInput
        label="Internal Install Hours (fallback)"
        field="install_hours"
        value={formData.install_hours}
        dispatch={dispatch}
        type="number"
        step="0.5"
        disabled={!isAdmin}
      />
      <FormInput
        label="Internal Install Rate ($/hr fallback)"
        field="install_labor_rate"
        value={formData.install_labor_rate}
        dispatch={dispatch}
        type="number"
        step="0.5"
        disabled={!isAdmin}
      />
      {/* "Community Labor Rate" was retired 2026-08-19 (owner ruling): install
			    is broken out as line items and the engine never read the field.
			    `community_labor_rate` stays in form state so old saved jobs load. */}
    </fieldset>
  );
}

export default InstallSection;
